import { forwardRef } from 'react';
import NextLink from 'next/link';
import { useTheme } from '@mui/material/styles';
import { Box, BoxProps } from '@mui/material';
import { lighten, opacify } from 'polished';
import { PATH_APP } from 'src/routes/paths';
import useAuth from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<any, Props>(({ disabledLink = false, sx }, ref) => {
  const theme = useTheme();
  const PRIMARY_LIGHT = '#ffb155';
  const PRIMARY_MAIN = theme.palette.primary.main;

  const { organization } = useAuth();

  const logo = (
    <Box ref={ref} sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}>
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.24 0H8.76C3.93 0 0 3.928 0 8.758v22.484C0 36.072 3.93 40 8.76 40h22.48c4.83 0 8.76-3.928 8.76-8.758V8.758C40 3.928 36.07 0 31.24 0z"
          fill={opacify(0.8, PRIMARY_MAIN)}
        />
        <path
          d="M20.325 29.515c-3.316.11-6.41-1.455-8.338-4.35a8.636 8.636 0 01-1.13-2.473c-.916-3.294-.118-6.624 2.046-9.046 1.115-1.24 2.57-2.112 4.15-2.658 1.175-.406 2.068-.517 2.954-.517a9.512 9.512 0 017.268 3.382 1.186 1.186 0 001.558.229l.997-.672c.576-.384.71-1.19.266-1.72-3.072-3.73-8.168-5.724-13.53-4.32a12.3 12.3 0 00-4.07 1.905c-4.483 3.219-6.477 8.587-5.17 13.963a12.358 12.358 0 001.928 4.216c2.563 3.604 6.514 5.612 10.739 5.612.155 0 .303 0 .458-.007 3.493-.118 6.617-1.61 8.892-3.928.48-.495.413-1.3-.118-1.728l-.931-.753c-.473-.384-1.152-.325-1.588.103a9.477 9.477 0 01-6.38 2.762z"
          fill={lighten(0.3, PRIMARY_LIGHT)}
        />
        <path
          d="M29.69 15.521h.037c.864 0 1.573.702 1.573 1.573 0 .864-.702 1.573-1.573 1.573h-.037a1.574 1.574 0 01-1.573-1.573c0-.871.709-1.573 1.573-1.573zM29.69 22.13h.037c.864 0 1.573.702 1.573 1.573 0 .864-.702 1.573-1.573 1.573h-.037a1.574 1.574 0 01-1.573-1.573c0-.871.709-1.573 1.573-1.573zM20.128 26.974a6.84 6.84 0 006.84-6.841 6.84 6.84 0 10-13.68 0 6.84 6.84 0 006.84 6.841z"
          fill={lighten(0.3, PRIMARY_LIGHT)}
        />
      </svg>
    </Box>
  );

  if (disabledLink || !organization) {
    return <>{logo}</>;
  }

  return (
    <NextLink
      href={{
        pathname: PATH_APP.me.root,
        query: { organizationName: organization },
      }}
      legacyBehavior
    >
      {logo}
    </NextLink>
  );
});

export default Logo;
